export const getProductValue = (value) => {
  // const { value } = product || {};
  return value && typeof value === "object" ? value.value : value;
};
